var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('vue-friendly-iframe',{ref:"iframeEl",style:({ height: _vm.height }),attrs:{"src":_vm.src,"frameborder":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }